module.exports = __webpack_public_path__ + "img/cps_preview_pt.08be87a2.png";